<template>
  <button
    aria-label="Hilfe für dieses Feld anzeigen"
    class="form-help-button"
    type="button"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'CFormHelpButton'
}
</script>

<style scoped>
.form-help-button {
  margin-left: 5px;
  width: 24px;
  height: 24px;
  vertical-align: middle;

  background: var(--color-brand) url("~@/assets/form-help.svg") center / 10px no-repeat;
  border: 0;
  border-radius: 50%;
}
</style>
